import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { VERIFICATION_CODE } from 'constants/formFields';
import { verificationCodeSchema } from 'utils/validators';

import type { TUseVerificationCodeForm } from './interfaces/TUseVerificationCodeForm';

const useVerificationCodeForm = () => {
  const {
    control,
    handleSubmit,
    formState,
    setError,
  } = useForm<TUseVerificationCodeForm>({
    mode: 'onSubmit',
    resolver: yupResolver(verificationCodeSchema),
    defaultValues: {
      [VERIFICATION_CODE]: '',
    },
  });
  const { isValid } = formState;

  return {
    control,
    handleSubmit,
    isValid,
    setError,
  };
};

export default useVerificationCodeForm;
